import api from '@/helpers/api'
import qs from 'qs'

export default {
  getDokter (data) {
    return api.get('/dokter?' + qs.stringify(data))
  },
  getDokterDetail (id) {
    return api.get('/dokter/' + id)
  },
  addDokter (dokter) {
    return api.post('/dokter', qs.stringify(dokter))
  },
  updateDokter (id, dokter) {
    return api.patch('/dokter/' + id, qs.stringify(dokter))
  },
  deleteDokter (id) {
    var dokter = []
    return api.delete('/dokter/' + id, qs.stringify(dokter))
  }
}
